module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/cart-c50afa1d76bad67e882282c4640a0b1e.svg";